let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e6ONP")).then(() => parcelRequire('gu2ky'));